
define(['jquery', 'underscore', 'core', 'app-common/lib/jquery.velocity'], function($) {
  var $spinnerWrapper, isLoading;
  $spinnerWrapper = null;
  isLoading = function() {
    return $spinnerWrapper != null ? $spinnerWrapper.is(':visible') : void 0;
  };
  return {
    init: function(settings) {
      if (settings == null) {
        settings = {};
      }
      if (settings.spinnerContainer) {
        settings.inline = true;
      }
      if (settings.modal) {
        settings.small = true;
      }
      if (isLoading() && !settings.modal && !settings.inline) {
        return;
      }
      $spinnerWrapper = $('<div id="bench-spinner" loading-spinner style="opacity: 0;">\
                    <div cube-container>\
                        <div cube1></div>\
                        <div cube2></div>\
                    </div>\
                </div>');
      if (settings.modal) {
        $spinnerWrapper.attr('loading-spinner', 'modal-spinner');
        $('.modal:visible').append($spinnerWrapper);
      } else if (settings.dialog) {
        $spinnerWrapper.attr('loading-spinner', 'modal-spinner');
        $('#dialog-window:visible').append($spinnerWrapper);
      } else {
        if (settings.noBg) {
          $spinnerWrapper.attr('loading-spinner', 'no-bg');
        }
        if (settings.wide) {
          $spinnerWrapper.attr('loading-spinner', 'wide');
        }
        if (settings.inline) {
          $spinnerWrapper.attr('loading-spinner', 'inline');
        }
        $(settings.spinnerContainer || 'body').append($spinnerWrapper);
      }
      return $spinnerWrapper.velocity('stop').velocity('transition.fadeIn', 20);
    },
    hide: function() {
      var $fadingSpinnerWrapper;
      $fadingSpinnerWrapper = $spinnerWrapper;
      $spinnerWrapper = null;
      return $fadingSpinnerWrapper != null ? $fadingSpinnerWrapper.velocity('stop').velocity('transition.fadeOut', {
        duration: 200,
        complete: function() {
          return $fadingSpinnerWrapper.remove();
        }
      }) : void 0;
    },
    isLoading: isLoading
  };
});
